// src/pages/shared/NoAccessPage.js
import React from 'react';

const NoAccessPage = () => (
  <div style={{ textAlign: 'center', padding: '50px' }}>
    <h2>ليس لديك صلاحية الوصول لهذه الصفحة.</h2>
  </div>
);

export default NoAccessPage;
